import { defineMessages } from 'react-intl';

const scope = 'app.components.ProgressRadialBar';

export default defineMessages({
    outOfTotalLabel: {
        id: `${scope}.labels.outOfTotal`,
        description: 'Label inside circle containing the total value',
        defaultMessage: 'out of {total}',
    },
});
